export default "__VITE_ASSET__CMpVs7RU__"